import React from "react";
import Link from "next/link";
import { ISrcSet, Picture } from "@kursk/components/ui/Picture/Picture";
import { BackArrowIcon, VirtualMuseumIcon } from "@kursk/components/ui/icons";
import styles from "./VirtualMuseum.module.scss";

export const VirtualMuseum = ({ place }) => {
  const { image } = place;
  const srcSet: ISrcSet[] = [
    {
      media: '(min-width: 768px)',
      width: 600,
      height: 400,
      cropMode: 'noCrop',
    },
    {
      media: '(max-width: 767px)',
      width: 335,
      height: 224,
      cropMode: 'noCrop',
    }
  ]

  return <Link href={place.virtualMuseum} passHref>
    <a target='_blank' rel="noreferrer">
      <div className={styles.image}>
        <Picture srcSet={srcSet} image={image}/>
        <div className={styles.shadow}/>
        <div className={styles.iconWrapper}>
          <VirtualMuseumIcon/>
          <div className={styles.textWrapper}>
            <div className={styles.text}>ВИРТУАЛЬНЫЙ ТУР ПО МУЗЕЮ</div>
            <BackArrowIcon/>
          </div>
        </div>
      </div>
    </a>
  </Link>
}
